<template>
  <Dialog ref="chat-dialog" position="right" :autoClose="autoClose">
    <div class="dg-mk-container">
      <view class="markdown-body" v-html="md.render(content)"></view>
    </div>
  </Dialog>
</template>
<script>
import MarkdownIt from 'markdown-it';
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
			md: new MarkdownIt({
				html: true,
				xhtmlOut: false,
				breaks: true,
				linkify: true
			}),
    }
  },
  methods: {
    open() {
      this.show()
    },
    hide() {
      this.close()
    },
    show() {
      this.$refs['chat-dialog'].show()
    },
    close() {
      this.$refs['chat-dialog'].close()
    }
  }
}
</script>
<style lang="scss">
.dg-mk-container {
  width: 600px;
  height: calc(100vh - 120px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 10px 28px;
  margin: 10px 5px 10px 10px;
}
.markdown-body {
  box-sizing: border-box;
  margin: 0 auto;

  &:last-child {
    margin-bottom: 100px;
  }
  table {
    width: 100%;
    border-collapse: collapse; /* 合并边框 */
    margin: 20px 0;
    font-family: "Consolas", "Courier New", monospace;
    tr {
      &:hover {
        background-color: #fcfcfc;
      }
      &:nth-child(even) {
        background-color: #fcfcfc;
      }
    }
    th {
      border: 1px solid #ddd; /* 单元格边框 */
      padding: 12px 15px; /* 单元格内边距 */
      text-align: left;
      
      background-color: #f0f0f0; /* 表头背景色 */
      color: #000;
      font-weight: bold;
    }
    td {
      border: 1px solid #ddd; /* 单元格边框 */
      padding: 12px 15px; /* 单元格内边距 */
      text-align: left;
    }
    
  }
  code {
    font-family: "Consolas", "Courier New", monospace;
  }
  ol,ul {
    margin-left: 20px;
  }
  li {
    font-size: 16px;
    line-height: 27px;
  }
  h1 {
    margin-bottom: 5px;
    font-size: 2.2em;
    line-height: 1.3;
  }
  h2 {
    margin: 15px 0 5px;
    font-size: 1.8em;
    line-height: 1.35;
  }
  h3 {
    margin: 10px 0 5px;
    font-size: 1.4em;
    line-height: 1.4;
  }
  h4 {
    margin: 10px 0 5px;
    font-size: 1.15em;
    line-height: 1.45;
  }
  p {
    margin-bottom: 5px;
    font-size: 16px;
    line-height: 27px;
  }
  hr {
    margin: 10px 0 20px;
  }
}
	
</style>